import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { ExternalLink } from '../../../../common/ExternalLink'
import { UseTimeZone } from '../../../../common/hooks/useTimeZone'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { Tooltip } from '../../../../common/tooltip'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import {
  formatText,
  formatVal,
  isInValidValue,
} from '../../../../helpers/value'
import { EMPTY_VALUE } from '../../../../utils/common'
import { selectCompanyOverview } from '../../store/slice'

import { OVERVIEW_KEYS } from './helper'
import classes from './index.module.scss'

export const InfoItem = ({ dataKey }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()

  const data = useSelector(
    selectCompanyOverview((overview) => overview[OVERVIEW_KEYS[dataKey]]),
  )

  const renderDataName = () => {
    const name = `companySummary.overview.${dataKey}`
    switch (OVERVIEW_KEYS[dataKey]) {
      case OVERVIEW_KEYS.NUMBER_OF_EMPLOYEES:
        return (
          <Element className="dFlex gap1">
            <Translate value={name} />
            <Tooltip
              tooltipContent="companySummary.overview.NUMBER_OF_EMPLOYEES_TOOLTIP"
              isI18n
              tooltipContentStyle={{ whiteSpace: 'nowrap', fontWeight: '400' }}
            >
              <Icon
                className="icon-info-circle"
                style={{ color: '#9C9C9C', fontSize: 13 }}
              />
            </Tooltip>
          </Element>
        )
      default:
        return <Translate value={name} />
    }
  }

  const renderDataValue = () => {
    if (isInValidValue(data)) return EMPTY_VALUE

    switch (OVERVIEW_KEYS[dataKey]) {
      case OVERVIEW_KEYS.COMPANY_TYPE:
        return (
          <Translate value={`companySummary.overview.companyType.${data}`} />
        )
      case OVERVIEW_KEYS.DATE_OF_REGISTRATION:
        return formatDateTime(data, FORMAT.DATE, locale, timezone)
      case OVERVIEW_KEYS.NUMBER_OF_EMPLOYEES:
        return formatVal(data, locale, false, 0)
      case OVERVIEW_KEYS.LEGAL_REPRESENTATIVE:
        return data.fullName || EMPTY_VALUE
      case OVERVIEW_KEYS.WEBSITE:
        return <ExternalLink href={data}>{data}</ExternalLink>
      default:
        return formatText(data)
    }
  }

  return (
    <Element className={classes.infoItem}>
      <Element className={classes.infoName}>{renderDataName()}</Element>
      <Element className={classes.infoData}>{renderDataValue()}</Element>
    </Element>
  )
}
